import { render } from "./EventFormManagementSystem.vue?vue&type=template&id=69b98554"
import script from "./EventFormManagementSystem.vue?vue&type=script&lang=js"
export * from "./EventFormManagementSystem.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__